/**
 * Rejects if `promise` hasn't settled within `ms`.
 *
 * For promises that own no abort mechanism of their own: Clerk's `getToken()`
 * awaits an internal "clerk is loaded" promise with no timeout and no reject
 * path, and `HTMLMediaElement.play()` may never settle on a stalled request.
 * Either await is otherwise unbounded, which is what leaves a loading spinner
 * running forever.
 *
 * The underlying work is not cancelled, only abandoned. Prefer an AbortSignal
 * where the API supports one (`fetch`).
 */
export function withTimeout<T>(
  promise: Promise<T>,
  ms: number,
  message: string
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  return Promise.race([
    promise,
    new Promise<never>((_resolve, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms)
    }),
  ]).finally(() => clearTimeout(timer))
}
